export default __webpack_public_path__ + "static/media/coop.ec43d97d.png";